import React, { useState } from "react";
import moment from "moment";

// Images, Icons, Documents
import LinkedInIcon from "assets/icons/social_media/LinkedinIcon";
import ComplaintAppealsPolicy2025 from "assets/documents/FITS02-01_Complaints_and_Appeals_Policy_Updated_April_2025.pdf";

function Footer() {
  return (
    <div className="bg-interlink-dark-grey text-sm py-10">
      <div className="max-w-navigation flex flex-col items-start gap-8 lg:flex-row sm:justify-between">
        <div className="text-white interlink-animation-translate-start">
          <p className="sm:w-[600px] mb-2 text-lg md:text-xl xl:text-2xl">
            at Interlink WE believe in empowering individuals and organisations
            through lifelong learning
          </p>
          <p className="mb-2 text-base md:text-lg xl:text-xl">
            © {moment().year()} Interlink Technology.
          </p>
          <ul className="ml-6 mb-6 list-disc text-xs md:text-sm">
            <li>
              <p>Interlink Technology Services Pty Ltd RTO 31926</p>
            </li>
            <li>
              <p>Interlink Technology Pty Ltd</p>
            </li>
            <li>
              <p>PT Interlink Technology Services Indonesia</p>
            </li>
          </ul>
          <a
            className="text-sm md:text-base underline"
            href={ComplaintAppealsPolicy2025}
            download="Complaints_and_Appeals_Policy.pdf"
          >
            Our Complaints and Appeal Policy.
          </a>
        </div>
        <div className="flex flex-col gap-8 lg:gap-28 justify-between items-start lg:items-end text-white interlink-animation-translate-start">
          <div>
            <p className="mb-3 text-left lg:text-right text-base md:text-lg xl:text-xl uppercase text-normal">
              Follow us on social media
            </p>
            <div className="flex flex-row lg:flex-row-reverse self-start lg:self-end gap-5">
              <a
                href="https://www.linkedin.com/company/interlink-technology-services-pty-ltd"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon className="w-[30px] h-[30px]" fill="white" />
              </a>
            </div>
          </div>
          <div>
            <p className="mb-3 text-left lg:text-right text-sm md:text-base xl:text-lg text-normal">
              Powered by{" "}
              <a
                href="https://www.cloudxier.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cloudxier
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
